module.exports = __webpack_public_path__ + "img/26.5b376c70.png";